import React, { useState } from 'react'

import _ from 'lodash'
import { Filtro } from '../../utils/Filtro'
import { routes } from '../../constants'
import apiService from '../../services/api.service'
import { Column } from 'primereact/column'
import '../../index.scss'
import LtsLookup from './lts-lookup'
import { InputText } from 'primereact/inputtext'
import { getFiltroJoinUnidade } from '../../utils/filter-utils'

export default function LtsLookupBandeira(props) {
  const [filters, setFilters] = useState([])

  const columns = [
    {
      field: 'oid',
      header: 'Código',
      columnKey: 'oid',
      sortable: false,
      filter: true,
      columnSortField: 'oid',
      visible: true,
    },
    {
      field: 'cartao',
      header: 'Cartão',
      columnKey: 'cartao',
      columnSortField: 'cartao',
      sortable: true,
      filter: true,
      visible: true,
    },
    {
      field: 'codigo',
      header: 'Código',
      columnKey: 'codigo',
      columnSortField: 'codigo',
      sortable: true,
      filter: true,
      visible: true,
    },
    {
      field: 'formaPagamento',
      header: 'Forma Pagamento',
      columnKey: 'formaPagamento',
      columnSortField: 'formaPagamento',
      sortable: true,
      filter: true,
      visible: true,
    },
    {
      field: 'unidade_oid',
      header: '',
      columnKey: 'unidade_oid',
      columnSortField: 'unidade.oid',
      sortable: true,
      filter: true,
      visible: false,
    },
    {
      field: 'unidade_sigla',
      header: 'Unidade',
      columnKey: 'unidade_sigla',
      columnSortField: 'unidade.sigla',
      sortable: true,
      filter: true,
      visible: false,
    },
  ]

  const loadDataFn = (params) => {
    return apiService.post(`/lottustech/bandeiras/all`, params)
  }

  const onKeyPress = (e) => {
    const value = _.get(props, 'value', null)
    if (value) {
      const filters = [
        new Filtro('cartao', value, 'CONTEM'),
        new Filtro('codigo', value, 'CONTEM'),
        // new Filtro('formaPagamento', value, 'CONTEM'),
      ]
      setFilters(filters)
    }
  }

  const onComplete = (event) => {
    const value = event.query
    if (value) {
      const filters = [
        new Filtro('cartao', value, 'CONTEM'),
        new Filtro('codigo', value, 'CONTEM'),
        // new Filtro('formaPagamento', value, 'CONTEM'),
      ]
      setFilters(filters)
    }
  }

  const pathOnEditFn = () => {
    const oid = _.get(props, 'oidRecord', null)
    if (oid) {
      return `${routes.PATH_BANDEIRA}/${oid}`
    } else {
      return `${routes.PATH_BANDEIRA}/novo`
    }
  }

  const onInputFilter = (e) => {
    const value = e.value
    if (typeof value === 'string') {
      props.onChange({
        oid: '',
        cartao: value,
      })
    } else {
      props.onChange(value)
    }
  }

  const autoCompleteTemplate = (data) => {
    return `${data.oid} - ${data.cartao}`
  }

  const onResolvingColumn = () => {
    return columns.map((col) => {
      // Remove props that should not be spread to DOM elements
      const { showFilterMenuOptions, showClearButton, showFilterMenu, ...columnProps } = col

      if (col.field === 'oid') {
        return (
          <Column
            {...columnProps}
            key={col.field}
            bodyClassName="column-codigo-body-width"
            filterHeaderClassName="column-codigo-filter-header-width"
            headerClassName="column-codigo-header-width"
            filterElement={columnFilterElement(col)}
          />
        )
      }
      if (col.field === 'cartao') {
        return (
          <Column
            {...columnProps}
            key={col.field}
            bodyClassName="column-descricao-body-width"
            filterHeaderClassName="column-descricao-filter-header-width"
            headerClassName="column-descricao-header-width"
            filterElement={columnFilterElement(col)}
          />
        )
      }
      return null
    })
  }

  const columnFilterElement = (column) => {
    return <InputText style={{ width: '100%' }} name={column.field} onChange={(e) => onChangeTableFilter(column, e)} />
  }

  const onChangeTableFilter = (column, e) => {
    const campo = column.field

    //remove o filtro do campo atual com valor 'antigo'
    const newFilters = filters.filter((f) => f.campo !== campo)

    const valor = _.get(e, 'target.value', null)
    if (valor) {
      const tipoFiltro = campo === 'oid' ? 'IGUAL_A' : 'CONTEM'
      newFilters.push({ campo, valor, tipoFiltro })
    }

    setFilters(newFilters)
  }

  const resolveFilters = (filters) => {
    if (props.formaPagamento) {
      const formaPagamento = props.formaPagamento
      filters.push(new Filtro('formaPagamento', formaPagamento, 'IGUAL_A'))
    }
    const oidUnidade = _.get(props, 'unidade.id', null)
    if (oidUnidade) {
      filters.push(getFiltroJoinUnidade(oidUnidade))
    }

    return filters
  }

  return (
    <React.Fragment>
      <LtsLookup
        label={props.label}
        value={props.value}
        name={props.name}
        field={props.field}
        history={props.history}
        autoCompleteTemplate={autoCompleteTemplate}
        onKeyPress={onKeyPress}
        onComplete={onComplete}
        onInputFilter={onInputFilter}
        pathOnEditFn={pathOnEditFn}
        header={props.label}
        columns={columns}
        onResolvingColumn={onResolvingColumn}
        loadDataFn={loadDataFn}
        resolveFilters={resolveFilters}
        onChange={props.onChange}
        filters={filters}
        setFilters={setFilters}
        editDisabled={props.editDisabled}
        editHidden={props.editHidden}
        disabled={props.disabled}
      />
    </React.Fragment>
  )
}
